"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DISPLAY_TYPES = void 0;
var client_1 = require("@apollo/client");
exports.GET_DISPLAY_TYPES = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query DisplayTypes($input: DisplayTypeInput!) {\n    displayTypes(input: $input) {\n      count\n      results {\n        name\n        id\n      }\n    }\n  }\n"], ["\n  query DisplayTypes($input: DisplayTypeInput!) {\n    displayTypes(input: $input) {\n      count\n      results {\n        name\n        id\n      }\n    }\n  }\n"])));
var templateObject_1;
